import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
// Images
import logo from "../../../resources/images/academyFinalWhite.png";

const Footer1 = ({ t }) => {
  return (
    <>
      <footer>
        <div className="footer-top">
          <div className="pt-exebar">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 center">
                  <Link to="/">
                    <img src={logo} alt="" className="image-footer-mobile" />
                  </Link>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-7 col-xs-8 center " />
                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 ">
                  <div className="pt-social-link">
                    <ul className="m-a0">
                      <li>
                        <a
                          href="https://www.facebook.com/Visionbizofficial"
                          target="_blank"
                          rel="noreferrer"
                          aria-label="Facebook"
                        >
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/accounts/login/?next=/visionbizofficial/"
                          target="_blank"
                          rel="noreferrer"
                          aria-label="Instagram"
                        >
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/visiontravelofficial"
                          target="_blank"
                          rel="noreferrer"
                          aria-label="YouTube"
                        >
                          <FaYoutube />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.tiktok.com/@visionbizofficial?"
                          target="_blank"
                          rel="noreferrer"
                          aria-label="TikTok"
                        >
                          <FaTiktok />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 block-center">
                  <div className="widget footer_widget">
                    <h6 className="footer-title">{t("footer.company")}</h6>
                    <ul>
                      <li>
                        <Link to="/about-us">{t("footer.us")}</Link>
                      </li>
                      <li>
                        <Link to="/privacity">{t("footer.privacity")}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 block-center">
                  <div className="widget footer_widget">
                    <h6 className="footer-title">{t("footer.courses")}</h6>
                    {/* ACADEMY-34 #4 — antes había dos ítems que
                        confundían: "Cursos más buscados" iba a `/`
                        (home, no a un listado de populares) y "Chat"
                        duplicaba el `ChatFab` flotante. Ahora un solo
                        link honesto a `/courses` — el chat vive solo
                        en el icono flotante inferior derecho. */}
                    <ul>
                      <li>
                        <Link to="/courses">{t("footer.explore")}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                {" "}
                © {new Date().getFullYear()}{" "}
                <span className="text-white">VisionBiz Academy</span>.{" "}
                {t("footer.reserved")}.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer1;
